import { render } from "./reportSubmitted.vue?vue&type=template&id=4b153134&scoped=true"
import script from "./reportSubmitted.vue?vue&type=script&lang=js"
export * from "./reportSubmitted.vue?vue&type=script&lang=js"

import "./reportSubmitted.vue?vue&type=style&index=0&id=4b153134&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b153134"]])

export default __exports__